import { useEffect, useState } from 'react'

/** Lee una media query y se mantiene al día. Sin ventana (pruebas, SSR) devuelve el valor por defecto. */
function useMedia(consulta: string, porDefecto: boolean): boolean {
  const [coincide, setCoincide] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia ? porDefecto : window.matchMedia(consulta).matches,
  )
  useEffect(() => {
    if (!window.matchMedia) return
    const m = window.matchMedia(consulta)
    const alCambiar = () => setCoincide(m.matches)
    alCambiar()
    m.addEventListener('change', alCambiar)
    return () => m.removeEventListener('change', alCambiar)
  }, [consulta])
  return coincide
}

/** Regla innegociable (DESIGN.md 23.1): con movimiento reducido no hay entradas, parallax ni bucles. */
export const usePrefiereMenosMovimiento = () => useMedia('(prefers-reduced-motion: reduce)', false)

/** Puntero fino (ratón): los efectos magnéticos y de inclinación no se aplican en táctil. */
export const useCursorFino = () => useMedia('(pointer: fine)', false)

type ConexionNavegador = { saveData?: boolean }

/** El usuario pidió ahorrar datos: no se cargan fondos WebGL. */
export function ahorroDeDatos(): boolean {
  const c = (navigator as Navigator & { connection?: ConexionNavegador }).connection
  return Boolean(c?.saveData)
}

/** ¿El navegador puede crear un contexto WebGL? */
export function webglDisponible(): boolean {
  try {
    const lienzo = document.createElement('canvas')
    return Boolean(lienzo.getContext('webgl2') ?? lienzo.getContext('webgl'))
  } catch {
    return false
  }
}

/** ¿La ventana mide al menos `px` de ancho? Para elegir entre una pieza animada y su versión simple. */
export const useAnchoMinimo = (px: number) => useMedia(`(min-width: ${px}px)`, true)
